import {PlatformController, ObsidianActionHooks} from './types';
import {
  SpotifyController,
  SoundCloudController,
  AppleMusicController,
} from './controllers';
import {Song, Platform} from '../../types';
import {Queue} from '../Queue';

export default class Obsidian {
  private queue: Queue;
  private upNext: Queue;
  private targetProvider?: Platform;
  private appleMusicController: PlatformController;
  private spotifyController: PlatformController;
  private soundCloudController: PlatformController;

  constructor(actions: ObsidianActionHooks, queue: Queue, upNext: Queue) {
    this.queue = queue;
    this.upNext = upNext;
    this.appleMusicController = new AppleMusicController(
      actions,
      this.queue,
      this.upNext,
    );
    this.spotifyController = new SpotifyController(actions);
    this.soundCloudController = new SoundCloudController(actions);
  }

  setTargetProvider(targetProvider: Platform) {
    this.targetProvider = targetProvider;
  }

  stop() {
    this.targetController.stop();
  }

  play({id}: Song, platform: Platform = Platform.AppleMusic) {
    this.setTargetProvider(platform);
    console.log(this.targetController);
    this.targetController.play(id, () => {});
  }

  //  TODO: this is temp for faster dev until stronger types
  playBySpotifyId(id: string) {
    if (this.targetController) {
      this.targetController.pause();
    }
    this.setTargetProvider(Platform.Spotify);
    this.targetController.play(id, () => {});
  }

  pause() {
    this.targetController.pause();
  }

  togglePlay() {
    this.targetController.togglePlay();
  }

  seek(position: number, cb?: () => void) {
    this.targetController.seek(position, cb);
  }

  nextTrack() {
    this.targetController.nextTrack();
  }

  previousTrack() {
    this.targetController.nextTrack();
  }

  setVolume(value: number) {
    this.targetController.setVolume(value);
  }

  changeTargetProvider(targetProvider: Platform) {
    this.targetProvider = targetProvider;
  }

  isReady() {
    return this.targetController.isReady();
  }

  async initializeSpotify(secret: string) {
    return await this.spotifyController.initialize(secret);
  }

  initializeSoundcloud(secret: string) {
    this.soundCloudController.initialize(secret);
  }

  initializeAppleMusic() {
    this.appleMusicController.initialize('a');
  }

  getPlatformState(platform: Platform) {
    return this.controllerFromPlatform(platform).getState();
  }

  private get targetController(): PlatformController {
    return this.controllerFromPlatform(this.targetProvider);
  }

  private controllerFromPlatform(
    platform: Platform | undefined,
  ): PlatformController {
    switch (platform) {
      case Platform.AppleMusic:
        return this.appleMusicController;
      case Platform.Spotify:
        return this.spotifyController;
      case Platform.Soundcloud:
        return this.soundCloudController;
      default:
        return this.appleMusicController;
    }
  }
}
